/**
 * Date-math helpers shared across compliance pages. Pulled out of the per-page
 * inline copies (`monthsAgo` / `monthsAgoIso` / `monthsAgoLocal`) so freshness
 * coloring + at-risk thresholds compute identically everywhere.
 */

/**
 * Whole-month delta from `iso` to "now" (positive = past, negative = future).
 * Returns `Infinity` for null / undefined / unparseable input so it can act as
 * a sort-key sentinel without callers special-casing the missing case.
 *
 * Pure: only Date + Number APIs, no globals beyond `new Date()` for "now".
 */
export function monthsAgo(iso: string | null | undefined): number {
  if (!iso) return Infinity;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return Infinity;
  const now = new Date();
  return (now.getFullYear() - d.getFullYear()) * 12 + (now.getMonth() - d.getMonth());
}
